import Lrc from "./LRC/Routes";
import Reports from "./Reports/Route";
import Settings from "./Settings/Routes";
import VisitorProfile from "./VisitorProfile/Route";
import Visitor from "./Visitor/Route";

export default [...Visitor, ...VisitorProfile, ...Reports, ...Lrc, ...Settings];
